<template>
  <v-app>
    <dashboard-core-app-bar v-model="hideDrawer" />

    <dashboard-core-drawer
      :items="drawerItems"
      :expand-on-hover.sync="hideDrawer"
    />

    <dashboard-core-view />
  </v-app>
</template>

<script>
  import {
    mapState,
  } from 'vuex'
  export default {
    name: 'DashboardIndex',
    components: {
      DashboardCoreAppBar: () => import('@/components/core/AppBar'),
      DashboardCoreDrawer: () => import('@/components/core/Drawer'),
      DashboardCoreView: () => import('@/components/core/View'),
    },
    data: () => ({
      drawerItems: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/',
        },
        {
          icon: 'account_balance',
          title: 'sales',
          group: '',
          children: [
            {
              icon: 'mdi-tag',
              title: 'labels',
              to: 'labels',
            },
            {
              icon: 'mdi-account',
              title: 'customers',
              to: 'customers',
            },
            {
              title: 'specifications',
              to: 'specifications',
            },
            {
              title: 'consolidated_invoices',
              to: 'consolidated_invoices',
            },
            {
              title: 'claims',
              to: 'claims',
            },
            {
              group: '/payments',
              icon: 'credit_card',
              title: 'payments',
              children: [
                {
                  title: 'quickpay',
                  group: '/payments/quickpay',
                  children: [
                    {
                      to: 'creditcard',
                      title: 'credit_card',
                    },
                    {
                      to: 'subscription',
                      title: 'subscription',
                    },
                  ],
                },
                {
                  title: 'valitor',
                  group: '/payments/valitor',
                  children: [
                    {
                      to: 'creditcard',
                      title: 'credit_card',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          icon: 'monetization_on',
          title: 'prices',
          group: '',
          children: [
            {
              title: 'price_groups',
              to: 'price-groups',
            },
            {
              icon: 'local_shipping',
              title: 'carriers',
              group: '',
              children: [
                {
                  title: 'carriers',
                  to: 'carriers',
                },
                {
                  title: 'agreements',
                  to: 'carrier-agreements',
                },
                {
                  title: 'fees',
                  to: 'carrier-fees',
                },
              ],
            },
            {
              group: '/transit',
              icon: 'mdi-directions-fork',
              title: 'linehaul',
              children: [
                {
                  title: 'linehaul',
                  to: 'linehaul',
                },
                {
                  title: 'linehaul_routes',
                  to: 'linehaul/routes',
                },

              ],
            },
            {
              title: 'transit',
              to: 'transit/prices',
            },
            {
              icon: 'mdi-cash-multiple',
              title: 'currencies',
              to: 'currencies',
            },
            {
              icon: 'mdi-cash-multiple',
              title: 'dimensions',
              to: 'dimensions',
            },
            {
              icon: 'mdi-cash-multiple',
              title: 'fuels',
              to: 'fuels',
            },
            {
              icon: 'mdi-package-variant',
              title: 'packaging_products',
              to: 'packaging-products',
            }, {
              icon: 'mdi-barcode',
              title: 'barcodes',
              to: 'barcodes',
            },
            {
              title: 'product_groups',
              to: 'product-groups',
            },

          ],
        },

        {
          group: '/tools',
          icon: 'mdi-cogs',
          title: 'tools',
          children: [
            {
              title: 'consolidated_invoices',
              to: 'consolidated-invoices',
            },
            {
              title: 'pallet_missing',
              to: 'pallet-missing',
            },
            {
              title: 'tracking_codes',
              to: 'tracking',
            },
            {
              title: 'translations',
              to: 'translations',
            },
            {
              title: 'file',
              to: 'file',
            },
            {
              title: 'style_guide',
              to: 'style-guide',
            },
            {
              group: '/tools/app',
              icon: 'phone_iphone',
              title: 'app',
              children: [
                {
                  title: 'versions',
                  to: 'versions',
                },
                {
                  title: 'devices',
                  to: 'devices',
                },
              ],
            },
            {
              group: '/logs',
              icon: 'notes',
              title: 'logs',
              children: [
                {
                  title: 'client',
                  to: 'client',
                },
                {
                  title: 'input',
                  to: 'input',
                },
                {
                  title: 'address',
                  to: 'address',
                },
              ],
            },
            {
              group: '/misc',
              icon: 'misc',
              title: 'misc',
              children: [
                {
                  title: 'mail',
                  to: 'mail',
                },
                {
                  title: 'group',
                  to: 'group',
                },
                {
                  title: 'Sql Job',
                  to: 'sql-jobs',
                },
              ],
            },
          ],
        },
        {
          icon: 'mdi-account',
          title: 'users',
          to: '/users',
        },

      ],

    }),
    computed: {
      ...mapState(['hideDrawer']),
      hideDrawer: {
        get () {
          return this.$store.state.hideDrawer
        },
        set (val) {
          this.$store.commit('SET_HIDE_DRAWER', val)
        },
      },
    },
  }
</script>
